import _classCallCheck from 'babel-runtime/helpers/classCallCheck';
import _createClass from 'babel-runtime/helpers/createClass';
import _possibleConstructorReturn from 'babel-runtime/helpers/possibleConstructorReturn';
import _inherits from 'babel-runtime/helpers/inherits';
import _taggedTemplateLiteral from 'babel-runtime/helpers/taggedTemplateLiteral';

var _templateObject = _taggedTemplateLiteral(['\n  padding: 24px;\n  background-color: ', ';\n  border-bottom: 1px solid ', ';\n'], ['\n  padding: 24px;\n  background-color: ', ';\n  border-bottom: 1px solid ', ';\n']);

import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import { ReactionSign } from './ReactionSign';
import { styles, translations } from 'gipsy-misc';

var HeaderContainer = styled.div(_templateObject, styles.colors.backgroundGreyColor, styles.colors.borderColor);

var ReactionHeader = function (_PureComponent) {
  _inherits(ReactionHeader, _PureComponent);

  function ReactionHeader() {
    var _ref;

    var _temp, _this, _ret;

    _classCallCheck(this, ReactionHeader);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = ReactionHeader.__proto__ || Object.getPrototypeOf(ReactionHeader)).call.apply(_ref, [this].concat(args))), _this), _this.onChange = function (data) {
      var isAssignee = _this.props.isAssignee;

      if (isAssignee) {
        return;
      }
      return _this.props.onChange(data);
    }, _temp), _possibleConstructorReturn(_this, _ret);
  }

  _createClass(ReactionHeader, [{
    key: 'render',
    value: function render() {
      var _props = this.props,
          isAssignee = _props.isAssignee,
          assignee = _props.assignee,
          reactions = _props.reactions;

      var hasReaction = reactions && reactions.length > 0;

      var message = void 0;
      if (isAssignee) {
        message = hasReaction ? translations.taskPanel.reactions.gotCongrats : '';
      } else {
        message = hasReaction ? translations.taskPanel.reactions.gaveCongrats : translations.taskPanel.reactions.shouldGiveCongrats;
        message = message.replace('[displayName]', assignee);
      }

      var clapReactions = void 0,
          loveHandReactions = void 0,
          okHandReactions = void 0,
          thumbsUpReactions = void 0;
      if (hasReaction) {
        clapReactions = reactions.filter(function (r) {
          return r.reaction === '👏';
        });
        loveHandReactions = reactions.filter(function (r) {
          return r.reaction === '🤟';
        });
        okHandReactions = reactions.filter(function (r) {
          return r.reaction === '👌';
        });
        thumbsUpReactions = reactions.filter(function (r) {
          return r.reaction === '👍';
        });
      }

      return React.createElement(
        HeaderContainer,
        null,
        React.createElement(
          'span',
          null,
          message
        ),
        React.createElement(ReactionSign, {
          isAssignee: isAssignee || false,
          hasReaction: hasReaction,
          active: !hasReaction || clapReactions.length > 0,
          sign: '\uD83D\uDC4F',
          reactions: clapReactions,
          onClick: this.onChange
        }),
        React.createElement(ReactionSign, {
          isAssignee: isAssignee || false,
          hasReaction: hasReaction,
          active: !hasReaction || loveHandReactions.length > 0,
          sign: '\uD83E\uDD1F',
          reactions: loveHandReactions,
          onClick: this.onChange
        }),
        React.createElement(ReactionSign, {
          isAssignee: isAssignee || false,
          hasReaction: hasReaction,
          active: !hasReaction || okHandReactions.length > 0,
          sign: '\uD83D\uDC4C',
          reactions: okHandReactions,
          onClick: this.onChange
        }),
        React.createElement(ReactionSign, {
          isAssignee: isAssignee || false,
          hasReaction: hasReaction,
          active: !hasReaction || thumbsUpReactions.length > 0,
          sign: '\uD83D\uDC4D',
          reactions: thumbsUpReactions,
          onClick: this.onChange
        })
      );
    }
  }]);

  return ReactionHeader;
}(PureComponent);

ReactionHeader.propTypes = {
  reactions: PropTypes.array,
  assignee: PropTypes.string,
  onChange: PropTypes.func.isRequired,
  isAssignee: PropTypes.bool
};


export default ReactionHeader;
//# sourceMappingURL=index.js.map


//////////////////
// WEBPACK FOOTER
// ../gipsy-ui/lib/TaskPanel/components/Header/ReactionHeader/index.js
// module id = 1093
// module chunks = 0